<template>
  <div>
    <a-spin :spinning="loading">
      <a-form-model layout="vertical" :model="persona" :rules="formRules"
                    @submit.native.prevent @submit="guardarDatosPersonales" ref="datos_personales">
        <a-tabs :active-key="keyTab" @change="changeTab">
          <a-tab-pane key="0" force-render>
          <span slot="tab">
            <a-icon type="idcard"/>
            Identificación
          </span>
            <a-card>
              <a-row v-if="persona" :gutter="[16,16]" :md="12" :xs="24">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Nombre completo')"  prop="name" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             v-model="persona.name"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Primer apellido')" prop="last_name1" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             v-model="persona.last_name1"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Segundo apellido')" prop="last_name2" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             v-model="persona.last_name2"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tipo de documento')" prop="type_id" has-feedback>
                    <a-input style="width: 100%"
                             readOnly
                             v-model="persona.type_id"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Identificación')" prop="identification" has-feedback>
                    <a-input style="width: 100%"
                             readOnly
                             v-model="persona.id_person"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Pais de expedición')" prop="id_h_country_expedition" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="persona.id_h_country_expedition"
                                         :selectedObj.sync="dropdown.country_expedition_selected"
                                         endpoint="hierarchy_lookup"
                                         :customSlots="['suffixIcon']"
                                         :params="request.paises"
                    >
                      <template slot="suffixIcon">
                        <img style="max-width: 20px"
                             :src="flags[dropdown.country_expedition_selected.equivalency]"
                             alt=""
                             v-if="dropdown.country_expedition_selected && dropdown.country_expedition_selected.equivalency">
                      </template>
                    </form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ciudad de expedición')" prop="id_h_city_expedition" has-feedback>
                    <form-model-lookup style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="persona.id_h_city_expedition"
                                       placeholder="Ciudad de Expedición"
                                       :params="{h_lookup_type: 'CIUDADES_HV'}">
                    </form-model-lookup>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha de expedición')" prop="date_expedition_cc">
                    <a-date-picker style="width: 100%"
                                   placeholder="Fecha Expedición"
                                   v-model="persona.date_expedition_cc"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                    ></a-date-picker>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Id Netsuite')"
                                     v-if="$getConfigValue('MOSTRAR_ID_NETSUITE_HV', 'SI') === 'SI'"
                                     prop="name"
                                     has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             v-model="persona.id_netsuite"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>


          <a-tab-pane key="1" force-render>
          <span slot="tab">
            <a-icon type="gift"/>
            Nacimiento
          </span>
            <a-card>
              <a-row v-if="persona" :gutter="[16,16]" :md="12" :xs="24">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Pais de nacimiento')" prop="country_expedition_selected" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="persona.id_h_country_birth"
                                         :selectedObj.sync="dropdown2.country_expedition_selected"
                                         endpoint="hierarchy_lookup"
                                         :customSlots="['suffixIcon']"
                                         :params="request.paises"
                    >
                      <template slot="suffixIcon">
                        <img style="max-width: 20px"
                             :src="flags[dropdown2.country_expedition_selected.equivalency]"
                             alt=""
                             v-if="dropdown2.country_expedition_selected && dropdown2.country_expedition_selected.equivalency">
                      </template>
                    </form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ciudad de nacimiento')" prop="id_h_city_birth" has-feedback>
                    <form-model-lookup style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="persona.id_h_city_birth"
                                       placeholder="Ciudad de nacimiento"
                                       :params="{h_lookup_type: 'CIUDADES_HV'}">
                    </form-model-lookup>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha de nacimiento')" prop="date_birth">
                    <a-date-picker style="width: 100%"
                                   placeholder="Fecha Expedición"
                                   v-model="persona.date_birth"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                    ></a-date-picker>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Grupo sanguíneo')" prop="id_h_blood_group" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="persona.id_h_blood_group"
                                         endpoint="hierarchy_lookup"
                                         :params="request.grupo_sanguineo"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Factor RH')" prop="id_h_blood_rh" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="persona.id_h_blood_rh"
                                         endpoint="hierarchy_lookup"
                                         :params="request.factor_rh"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Género')" prop="gender" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="persona.gender"
                                         endpoint="hierarchy_lookup"
                                         :params="request.sexo"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Estado civil')" prop="id_h_marital_status" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="persona.id_h_marital_status"
                                         endpoint="hierarchy_lookup"
                                         :params="request.estado_civil"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ciudad de origen')" prop="id_h_origen_city" has-feedback>
                    <form-model-lookup style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="persona.id_h_origen_city"
                                       placeholder="Ciudad de origen"
                                       :params="{h_lookup_type: 'CIUDADES_HV'}">
                    </form-model-lookup>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>

          <a-tab-pane key="2" force-render>
          <span slot="tab">
            <a-icon type="home"/>
            Lugar de residencia permanente
          </span>
            <a-card>
              <a-row v-if="persona" :gutter="[16,16]" :md="12" :xs="24">
                <a-form-model-item v-bind="colSpan" :label="$t('Dirección')" prop="address">
                  <a-textarea placeholder="Dirección"
                              readOnly
                              autoSize
                              class="ant-uppercase"
                              v-model="persona.address"
                              v-on:click="modalDireccionVisible = true">
                  </a-textarea>
                </a-form-model-item>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Teléfono móvil I')" prop="celular1" has-feedback>
                    <a-input style="width: 100%"
                             v-model="persona.cell_phone1"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Teléfono móvil II')" prop="celular2" has-feedback>
                    <a-input style="width: 100%"
                             v-model="persona.cell_phone2"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Email corporativo')" prop="mail" has-feedback>
                    <a-input style="width: 100%"
                             v-model="persona.mail"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Email personal')" prop="personal_mail" has-feedback>
                    <a-input style="width: 100%"
                             v-model="persona.personal_mail"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Teléfono')" prop="phone_home" has-feedback>
                    <a-input style="width: 100%"
                             v-model="persona.phone_home"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ciudad de residencia')" prop="id_h_residence_city" has-feedback>
                    <form-model-lookup style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="persona.id_h_residence_city"
                                       placeholder="Ciudad de nacimiento"
                                       :params="{h_lookup_type: 'CIUDADES_HV'}">
                    </form-model-lookup>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Lugar de residencia')" class="ant-uppercase" prop="residence_place" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             v-model="persona.residence_place"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>
        </a-tabs>
        <a-affix :offset-bottom="10">
          <a-card style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
            <a-button v-if="!$userIsInrol('Query')"
              type="primary"
              html-type="submit">
              Guardar Cambios
            </a-button>
          </a-card>
        </a-affix>
        <direccion-estructurada v-model="persona.address" :visible="modalDireccionVisible"
                                :direccionActual="persona.address"
                                @cancel="modalDireccionVisible = false"
                                @success="direccionCambiada"></direccion-estructurada>
      </a-form-model>
    </a-spin>
  </div>
</template>
<script>
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['persona'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    },
    data () {
      return {
        modalDireccionVisible: false,
        keyTab: '0',
        loading: false,
        document_type: {
          h_lookup_type: 'TIPO_DOCUMENTO',
          use_code: true
        },
        request: {
          paises: {
            h_lookup_type: 'PAISES_HV'
          },
          ciudades: {
            h_lookup_type: 'CIUDADES_HV'
          },
          grupo_sanguineo: {
            h_lookup_type: 'GRUPO_SANGUINEO'
          },
          factor_rh: {
            h_lookup_type: 'RH'
          },
          sexo: {
            h_lookup_type: 'SEXO',
            use_code: true
          },
          estado_civil: {
            h_lookup_type: 'ESTADO_CIVIL'
          }
        },
        dropdown: {
          country_expedition_selected: {},
          country_birth_selected: {}
        },
        dropdown2: {
          country_expedition_selected: {},
          country_birth_selected: {}
        },
        flags: FLAGS,
        formRules: {},
        colSpan: {
          xs: 24,
          md: 8
        }
      }
    },
    methods: {
      direccionCambiada () {
        this.modalDireccionVisible = false
      },
      changeTab (e) {
        this.keyTab = e
      },
      guardarDatosPersonales () {
        if (this.loading) return
        this.$refs.datos_personales.validate(valid => {
          if (valid) {
            this.loading = true
            let request = {...this.persona}
            this.httpClient.getInstance().post('employee/guardar_datos_personales', request)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      initFormRules () {
        this.formRules = {
          name: [{required: false}],
          last_name1: [{required: false}],
          last_name2: [{required: false}],
          type_id: [{required: false}],
          identification: [{required: false}],
          id_h_country_expedition: [{required: false}],
          id_h_city_expedition: [{required: false}],
          date_expedition_cc: [{required: false}],
          country_expedition_selected: [{required: false}],
          id_h_city_birth: [{required: false}],
          date_birth: [{required: false}],
          id_h_blood_group: [{required: false}],
          id_h_blood_rh: [{required: false}],
          gender: [{required: false}],
          id_h_marital_status: [{required: false}],
          id_h_origen_city: [{required: false}],
          direccion: [{required: false}],
          celular1: [{required: false}],
          celular2: [{required: false}],
          mail: [{required: false},
            {type: 'email', message: 'Email no válido'}],
          personal_mail: [{required: false},
            {type: 'email', message: 'Email no válido'}],
          phone_home: [{required: false}],
          id_h_residence_city: [{required: false}],
          residence_place: [{required: false}],
          id_netsuite: [{required: false}]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeDatosPersonales.vue